import {
  Colors,
  InlineChildren,
  Inset,
  StackChildren,
  Text,
} from '@doordash/design-language'
import { Interpolate } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'
import { i18nKeys } from 'translationTypes'
import { BASE_GROWTH_IMAGE_CDN } from '../../../../constants'
import i18n from '../../../../i18n'

const verifyNccCheckImageUrl = `${BASE_GROWTH_IMAGE_CDN}/background-check/verify-ncc-check.png`

interface NccShareCompleteProps {
  email: string
}

const NccShareComplete: React.FC<NccShareCompleteProps> = ({ email }) => {
  return (
    <Inset isStretched>
      <StackChildren size={StackChildren.Sizes.Large}>
        <InlineChildren justifyContent={InlineChildren.Justification.Center}>
          <img
            src={verifyNccCheckImageUrl}
            alt={i18n.t(i18nKeys.backgroundCheckShare__nccComplete__altText)}
            height={228}
            width={255}
          />
        </InlineChildren>
        <StackChildren size={StackChildren.Sizes.Small}>
          <Text styles={Text.Styles.Body1} color={Colors.TextSecondary}>
            {i18n.t(i18nKeys.backgroundCheckShare__nccComplete__description1)}
          </Text>
          <Text styles={Text.Styles.Body1} color={Colors.TextSecondary}>
            <Interpolate
              i18n={i18n}
              i18nKey={i18nKeys.backgroundCheckShare__nccComplete__description2}
              values={{ ddEmail: email }}
              components={[
                <Text
                  display={Text.DisplayModes.Inline}
                  color={Colors.TextSecondary}
                />,
              ]}
            />
          </Text>
        </StackChildren>
      </StackChildren>
    </Inset>
  )
}

const mapStateToProps = state => ({
  email: state.application.email,
})

export default connect(mapStateToProps)(NccShareComplete)
